const styles = {
	wrapper: {
		backgroundRepeat: 'no-repeat',
		backgroundSize: 'cover',
		backgroundPosition: 'center',
		minHeight: ['300px', '320px'],
		borderRadius: '5px',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
		padding: '34px 30px 40px',
		'@media screen and (min-width: 1920px)': {
			minHeight: '325px',
			padding: '34px 40px 40px',
		},
		'::after': {
			content: '""',
			display: 'block',
			width: '100%',
			height: '100%',
			background: [
				'radial-gradient(rgba(0, 0, 0, 0.95) , rgba(0, 0, 0, 0))',
				'radial-gradient(rgba(0, 0, 0, 0.48) , rgba(0, 0, 0, 0))',
			],
			position: 'absolute',
			top: 0,
			left: 0,
			zIndex: 0,
		},		
	},
	content: {
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
		display: 'flex',	
		maxWidth: '300px',
		height: '4em',
		width: '100%',
		zIndex: 1,
		h1: {
			color: 'white',
			fontSize: ['6em', '6em'],
			lineHeight: '1em',
			fontWeight: '400',
			fontFamily: 'body',
		},
		h3: {
			color: 'white',
			fontSize: ['22px', '28px'],
			lineHeight: '1.607',
			fontWeight: '600',
			fontFamily: 'Open Sans, sans-serif',
			marginBottom: '8px',
		},		
		p: {
			color: 'white',
			fontSize: '20px',
			lineHeight: '1.785',
			textAlign: 'center',
		},
		a: {
			display: 'inline-block',
			textDecoration: 'none',
			textAlign: 'center',
		},
		button: {
			minWidth: '130px',
			minHeight: '45px',
			borderRadius: '5px',
			boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
			fontSize: '14px',
			fontWeight: '600',
			fontFamily: 'Open Sans, sans-serif',
			marginTop: '20px',
			transition: 'all 0.2s ease',
			'@media screen and (min-width: 768px)': {
				minWidth: '130px',
				minHeight: '45px',
			},
			':hover': {
				opacity: '0.999',
			},
		},
	},
	tag: {
		color: 'white',
		fontSize: '12px',
		fontWeight: '600',
		textTransform: 'uppercase',
		borderRadius: '5px',
		display: 'inline-block',
		padding: '5px 10px',
		marginBottom: '8px',
	},	
};

export default styles;
